export const logoConstants = {
    LOGO_SAVE_REQUEST        : 'LOGO_SAVE_REQUEST',
    LOGO_SAVE_SUCCESS        : 'LOGO_SAVE_SUCCESS',
    LOGO_SAVE_FAILURE        : 'LOGO_SAVE_FAILURE',
    LOGO_RESET_STATE        : 'LOGO_RESET_STATE',
};


